// Reuses the actual ComIQ favicon asset + faithful wordmark treatment (Inter 800, tight tracking).
const ASSET = "https://www.comiq.id/favicon.svg";

export const Logo = ({ inverted = false, showTagline = false }) => {
  const ink = inverted ? "#F5F1E8" : "#17140F";
  return (
    <a
      href="/"
      data-testid="comiq-logo"
      className="inline-flex items-center gap-2 no-underline"
      aria-label="ComIQ"
    >
      <img src={ASSET} alt="" width={26} height={26} className="rounded-[6px]" />
      <span
        style={{ color: ink, fontWeight: 800, letterSpacing: "-0.02em" }}
        className="text-[1.28rem] leading-none"
      >
        Com<span style={{ color: "#F2541B" }}>IQ</span>
      </span>
      {showTagline && (
        <span
          className="hidden sm:inline-block ml-2 pl-2 text-[0.72rem] font-medium"
          style={{ color: "#6A6256", borderLeft: "1px solid #D8CFBB" }}
        >
          Research Platform
        </span>
      )}
    </a>
  );
};
